export default __webpack_public_path__ + "static/media/14.790e0c45.jpg";